import { render } from "./AssignmentCardAdd.vue?vue&type=template&id=4a609660&scoped=true"
import script from "./AssignmentCardAdd.vue?vue&type=script&lang=js"
export * from "./AssignmentCardAdd.vue?vue&type=script&lang=js"

import "./AssignmentCardAdd.vue?vue&type=style&index=0&id=4a609660&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a609660"]])

export default __exports__